import { useCallback, useState } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import bookingPricingSlice from "./store/slice";
import styles from "./bookingPricing.module.scss";

type Props = {
  handleClose: () => void;
};

const BookingPricing = ({ handleClose }: Props) => {
  const { id } = useParams<string>();
  const dispatch = useDispatch();

  const [show, setShow] = useState<boolean>(true);

  const isLoading = useSelector((state) => state.bookingPricing.isLoading);

  const requestPricing = useCallback(
    (id: number) => dispatch(bookingPricingSlice.actions.request(id)),
    [dispatch]
  );

  const handleGentleClose = () => {
    setShow(false);

    setTimeout(() => {
      handleClose();
    }, 100);
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleGentleClose}
        backdrop="static"
        fullscreen="sm-down"
      >
        <Modal.Header closeVariant="white" closeButton>
          <Modal.Title>Ask for pricing</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Request will be sent to responsible manager. You will get confirmation
          by email.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleGentleClose}>
            Cancel
          </Button>
          <Button
            onClick={() => {
              requestPricing(Number(id));
              handleGentleClose();
            }}
          >
            Send request
            {isLoading && (
              <Spinner
                size="sm"
                animation="border"
                className={styles.loadMoreSpinner}
              />
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default BookingPricing;
